import React from 'react'

const Checkbox = props => {
  const {
    id,
    name,
    formSet,
    formRef = null,
    errors = {},
    onChange,
    inputLabelsMap,
    errorsMap,
    size = null,
    labelClassName = ''
  } = props

  const hasError = Boolean(errors[name]);

  return (
    <>
      <input
        id={id}
        name={`${formSet}[${name}]`}
        className={`input-option ${size}`}
        type="checkbox"
        onChange={e => onChange({ [name]: e.target.checked })}
        ref={formRef}
      />

      <label
        htmlFor={id}
        className={`label checkbox ${labelClassName} ${hasError && 'has-error'}`}
      >
        {inputLabelsMap[name]}
      </label>

      {errors && errors[name] && (
        <span className="input-error">{errorsMap[errors[name].type]}</span>
      )}
    </>
  )
}

export default Checkbox
